import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { useOptimisticDebouncedMutation } from "@/shared/lib/debounce/use-optimistic-debounced-mutation";
import { PricingByCard } from "../../pricing/components/pricing-by-card";
import { PricingCard } from "../../pricing/components/pricing-card";
import { PricingByPatch, PricingPatch } from "../../pricing/types/pricing";
import {
  updateOmniOfferCache,
  useOmniOfferPatchMutation,
} from "../api/offer-api";
import { Offer, patchOffer } from "../types/offer";
import { omniPricingByCardConfig } from "../../servicekindrules/omni-pricing-by-card-config";
import { omniPricingCardConfig } from "../../servicekindrules/omni-pricing-card-config";

export function OfferPricingPage({ offer }: { offer: Offer }) {
  const [patch] = useOptimisticDebouncedMutation(
    { id: offer.id },
    updateOmniOfferCache,
    useOmniOfferPatchMutation(),
  );

  const patchPricing = (pricing: PricingPatch) =>
    patch({ id: offer.id, pricing }, patchOffer(offer, { pricing }));
  const patchPricingBy = (pricingBy: PricingByPatch) =>
    patch({ id: offer.id, pricingBy }, patchOffer(offer, { pricingBy }));

  return (
    <div className="grid gap-2">
      <PricingCard
        pricing={offer.pricing}
        onPatch={patchPricing}
        disabled={isImmutable(offer)}
        {...omniPricingCardConfig}
      />
      <PricingByCard
        document={offer}
        pricingBy={offer.pricingBy}
        onPatch={patchPricingBy}
        disabled={isImmutable(offer)}
        {...omniPricingByCardConfig}
      />
    </div>
  );
}
